import { apiPaths } from 'src/services/api/apiPaths';
import HttpServiceInstance from 'src/services/api/http';

// Must match AnalyticsEventSerializer.ALLOWED_PROPERTIES in the backend, other properties are dropped there.
type AnalyticsPropertyKey =
  | 'module'
  | 'route'
  | 'dashboard'
  | 'report_type'
  | 'report_kind'
  | 'language'
  | 'file_format'
  | 'category';

export type AnalyticsProperties = Partial<
  Record<AnalyticsPropertyKey, string | null>
>;

/**
 * Sends a usage event to the backend. Failures are ignored.
 */
const trackEvent = (event: string, properties: AnalyticsProperties = {}) => {
  HttpServiceInstance.post(apiPaths.USAGE, {
    event,
    properties,
  }).catch(() => {});
};

export default trackEvent;
